export default {
    title: "Conjunto de Datos",
    list: {
        confirm_delete_title: "¿Le gustaría eliminar",
        confirm_delete_body:
            "Para evitar errores inesperados, asegúrese de que su conjunto no se esté utilizando en ninguna automatización/campaña.",
        empty_alert: "Todavía no tienes ningún Conjunto de Datos,",
        create_first: "¡crea el primero ahora!",
        filter_placeholder: "Filtrar por Nombre del Conjunto de Datos",
        create_new: "Crear Nuevo Conjunto de Datos",
        edit_tooltip: "Editar conjunto de datos",
        delete_tooltip: "Eliminar conjunto de datos",
        no_results: "No se encontraron conjuntos de datos con",
        error_loading: "Error al cargar los conjuntos de datos.",
        error_deleting: "Error al eliminar el conjunto de datos.",
        delete_success: "¡Conjunto de Datos eliminado con éxito!",
    },
    form: {
        edit_title: "Editar Conjunto de Datos",
        new_title: "Nuevo Conjunto de Datos",
        back: "Volver",
        basic_info: "Información Básica",
        name_label: "Nombre del Conjunto de Datos",
        name_placeholder: "Ej: Productos en Promoción",
        description_label: "Descripción",
        description_placeholder:
            "Describa el propósito de este conjunto de datos...",
        characters: "caracteres",
        data_structure: "Estructura de Datos",
        data_structure_help:
            "Configure las columnas y valores de su conjunto de datos",
        edit_with_ai: "Editar con IA",
        processing: "Procesando...",
        key_column: "Clave",
        column_name_placeholder: "Nombre de la Columna",
        default_value: "Valor Predeterminado",
        value_placeholder: "Valor",
        new_key_placeholder: "Nueva Clave",
        validation_empty_dataset:
            "Agregue al menos una fila al conjunto de datos.",
        validation_empty_headers:
            "Deben completarse todos los nombres de las columnas",
        validation_name_required: "El campo de nombre no puede estar vacío",
        validation_description_max:
            "El campo de descripción no puede exceder los 250 caracteres",
        error_loading: "Error al cargar el conjunto de datos.",
        error_saving: "Error al guardar el conjunto de datos.",
        edit_success: "¡Conjunto de Datos editado con éxito!",
        create_success: "¡Conjunto de Datos creado con éxito!",
        saving: "Guardando...",
        save_button: "Guardar Conjunto de Datos",
        cancel: "Cancelar",
        ai_modal_title: "Generar/Editar Dataset con IA",
        ai_modal_current: "Dataset Actual",
        ai_modal_columns: "Columnas:",
        ai_modal_rows: "Filas:",
        ai_modal_instructions: "Instrucciones para la IA",
        ai_modal_placeholder:
            "Describa lo que le gustaría crear o modificar. Por ejemplo:\n\nCREAR NUEVO DATASET:\n- Cree un dataset de productos tecnológicos con columnas: Nombre, Categoría, Precio, Marca, Stock. Genere 15 productos variados\n- Genere un dataset de clientes con 20 registros que incluyan nombre, correo electrónico, teléfono, ciudad, fecha_registro\n- Cree un dataset de promociones con columnas: Título, Descuento, Validez, Categoría, Código\n\nMODIFICAR EXISTENTE:\n- Agregue una columna 'Precio' con valores entre $10 y $100\n- Cree 5 nuevas filas con productos tecnológicos\n- Modifique la columna 'Categoría' para incluir 'Electrónica'\n\nIMPORTAR DATOS:\n- Pegue datos CSV o JSON aquí para importar\n\n¡La IA puede generar conjuntos de datos completamente nuevos o modificar los existentes!",
        ai_loading_messages: [
            "Analizando sus instrucciones...",
            "Procesando el dataset actual...",
            "Generando datos con IA...",
            "Aplicando las modificaciones...",
            "Finalizando el dataset...",
            "Casi listo...",
            "Sólo un momento...",
        ],
        ai_modal_generate: "Generar Dataset",
        validation_duplicate_key: "Error: La clave '{0}' ya existe.",
        ai_success: "¡Dataset generado/actualizado con IA!",
        ai_error_process: "Error al procesar con IA",
        ai_error_connection: "Error de comunicación con el servidor",
        ai_error_generic:
            "Error al procesar los cambios con IA. Inténtalo de nuevo.",
    },
};
